var _path, _line, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlightLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 167,
    viewBox: "0 0 24 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.94945 13.3704L8.61945 15.3804L9.65945 15.8204C9.81945 15.9004 9.95945 16.1104 9.95945 16.2904L9.95945 19.3504C9.95945 20.3104 10.6695 21.4504 11.5295 21.8904C11.8295 22.0404 12.1895 22.0404 12.4895 21.8904C13.3395 21.4504 14.0495 20.3004 14.0495 19.3404L14.0495 16.2804C14.0495 16.1004 14.1895 15.8904 14.3495 15.8104L20.0495 13.3604C20.6795 13.1004 21.1895 12.3104 21.1895 11.6304V10.3104C21.1895 9.46043 20.5495 9.04043 19.7595 9.38043L14.7495 11.5404C14.3595 11.7104 14.0395 11.5004 14.0395 11.0704V9.96043L14.0395 8.16043C14.0395 7.93043 14.1695 7.60043 14.3295 7.44043L16.6495 5.11043C16.8895 4.87043 16.9995 4.40043 16.8895 4.06043L16.4395 2.70043C16.2595 2.11043 15.5895 1.83043 15.0395 2.11043L12.6595 4.11043C12.2995 4.42043 11.7095 4.42043 11.3495 4.11043L8.96945 2.11043C8.41945 1.84043 7.74945 2.11043 7.54945 2.70043L7.09945 4.06043C6.98945 4.39043 7.09945 4.87043 7.33945 5.11043L9.65945 7.44043C9.82945 7.60043 9.95945 7.93043 9.95945 8.16043L9.95945 11.0704C9.95945 11.5004 9.64945 11.7004 9.24945 11.5404L4.23945 9.38043C3.44945 9.04043 2.80945 9.46043 2.80945 10.3104V11.6304C2.80945 12.3104 3.31945 13.1004 3.94945 13.3704Z",
    fill: "#1E1E1E"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.5,
    y1: 153,
    x2: 11.5,
    y2: 29,
    stroke: "#1E1E1E",
    strokeDasharray: "5 5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 162.5,
    r: 4.5,
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightLine);
export default __webpack_public_path__ + "static/media/flight-line.0588840b881baad91b4f739cf840e8e9.svg";
export { ForwardRef as ReactComponent };